import { memo } from 'react';
import { withStyles } from '@material-ui/core';
import DefaultSpinner from './DefaultSpinner';

const style = {
    root: {
        position: 'absolute',
        height: '100%',
    },
};

export default withStyles(style)(memo(DefaultSpinner));
